import React from 'react';
import ScrollTop from "./ScrollTop";
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from "react-icons/fi";
import SectionTitle from '../../elements/sectionTitle/SectionTitle';
import Whatsapp from '../../components/pageToTop/contactos/Whatsapp';


const FooterTwo = () => {
    return (
        <>
            <footer className="rn-footer footer-style-default variation-two">
                {/* <CalltoActionSeven /> */}
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            <div className="rwt-social-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                        <SectionTitle
                                            textAlign = "text-center"
                                            radiusRounded = ""
                                            subtitle = "Quédate con nosotros"
                                            title = "Nuestras redes sociales."
                                            description = ""
                                        />
                                </div>
                            </div>
                            <div className="row mt--30">
                                <div className="col-lg-12">
                                    <ul className="social-icon social-default">
                                        <li><a href="https://www.instagram.com/metodopanini/" target="_blank"><FiInstagram /></a></li>
                                        <li><a href="https://www.linkedin.com/company/metodopanini/?viewAsMember=true" target="_blank"><FiLinkedin /></a></li>
                                    </ul>
                                </div>

                            </div>
                            
                        </div>
                    </div>

                        </div>
                    </div>
                </div>
            </footer>
            <Whatsapp/>
            <ScrollTop />
        </>
    )
}

export default FooterTwo;
